import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useUnlinkBillit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/integrations/accountancy-software/unlink-billit', { method: 'POST' });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return { ...user, integrations: { ...user.integrations, billit: false } };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
